'use client'

import { CheckboxCT } from '@/components'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { Box, Button, Stack, Typography } from '@mui/material'
import { AnimatePresence, motion } from 'framer-motion'
import React, { useState } from 'react'
interface CheckboxFilterProps {
  attributeCode: string
  label: string
  icon?: string
  defaultOpen?: boolean
  options: AggregationsOption[]
  selectedValues: string[]
  onChange: (attributeCode: string, value: string) => void
}

/**
 * Component filter dạng checkbox cho gender, category, etc.
 * Có tính năng collapse section và pagination items
 */
export const CheckboxFilter: React.FC<CheckboxFilterProps> = ({
  attributeCode,
  label,
  icon,
  defaultOpen = false,
  options,
  selectedValues,
  onChange,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen)
  const [showAll, setShowAll] = useState(false)

  const INITIAL_ITEMS = 5
  const displayedOptions = showAll ? options : options.slice(0, INITIAL_ITEMS)
  const hasMore = options.length > INITIAL_ITEMS

  return (
    <Stack sx={{ mb: 1 }}>
      {/* Header collapsible */}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        onClick={() => setIsOpen(!isOpen)}
        sx={{ cursor: 'pointer', userSelect: 'none', py: 1 }}
      >
        <Typography
          sx={{
            fontSize: '16px',
            fontWeight: 700,
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            color: 'text.primary',
          }}
        >
          {icon && <Box component="span">{icon}</Box>}
          {label}
        </Typography>
        <motion.div animate={{ rotate: isOpen ? 180 : 0 }} transition={{ duration: 0.3 }}>
          <KeyboardArrowDownIcon sx={{ color: 'text.secondary' }} />
        </motion.div>
      </Stack>

      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: 'easeInOut' }}
            style={{ overflow: 'hidden' }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, py: 1 }}>
              {displayedOptions.map((option) => {
                const isChecked = selectedValues.includes(option.label)

                return (
                  <CheckboxCT
                    key={option.label}
                    slotProps={{
                      checkbox: {
                        checked: isChecked,
                        onChange: () => onChange(attributeCode, option.label),
                      },
                    }}
                    label={
                      <Typography
                        sx={{
                          fontSize: 14,
                          fontWeight: isChecked ? 600 : 300,
                          color: isChecked ? 'primary.main' : 'text.primary',
                        }}
                        component="div"
                        flex={1}
                        display="flex"
                        justifyContent="center"
                        alignItems={'center'}
                        width="100%"
                      >
                        <span>{option.label}</span>
                        {/* {option.count !== undefined && (
                          <span style={{ color: '#999', fontSize: '13px' }}>({option.count})</span>
                        )} */}
                      </Typography>
                    }
                  />
                )
              })}

              {/* Button Xem thêm / Thu gọn */}
              {hasMore && (
                <Button
                  onClick={() => setShowAll(!showAll)}
                  variant="text"
                  size="small"
                  sx={{
                    fontSize: 13,
                    fontWeight: 500,
                    color: 'primary.main',
                    textTransform: 'none',
                    p: 0,
                    minWidth: 'auto',
                    width: 'fit-content',
                    mt: 1,
                    '&:hover': {
                      bgcolor: 'transparent',
                      textDecoration: 'underline',
                    },
                  }}
                >
                  {showAll ? 'Thu gọn' : 'Xem thêm'}
                </Button>
              )}
            </Box>
          </motion.div>
        )}
      </AnimatePresence>
    </Stack>
  )
}
